import { render } from "./TraineeChooseTaskAttemptModal.vue?vue&type=template&id=d3fa0fa2&scoped=true"
import script from "./TraineeChooseTaskAttemptModal.vue?vue&type=script&lang=js"
export * from "./TraineeChooseTaskAttemptModal.vue?vue&type=script&lang=js"

import "./TraineeChooseTaskAttemptModal.vue?vue&type=style&index=0&id=d3fa0fa2&scoped=true&lang=css"
/* custom blocks */
import block0 from "./TraineeChooseTaskAttemptModal.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3fa0fa2"]])

export default __exports__